export const title = 'TripleMars';
